import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { ScreenshotLayout, ScreenshotLayoutConfig } from './layouts/ScreenshotLayout';

export type ScreenshotScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.Screenshot,
  ScreenshotLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  ScreenshotScreenConfig<ScreenNames>,
  ScreenNames
>;

export const ScreenshotScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => (
  <ScreenWrapper>
    <ScreenshotLayout onPressPrimaryButton={() => props.navigation.next(props)} {...props.layout} />
  </ScreenWrapper>
);
